import axios, { type AxiosResponse } from "axios";
import { UserInfo } from "@/models/AuthUser";
import { TblMServiceService } from "@/services/TblMServiceService";
import { TblMSogoServiceService } from "@/services/TblMSogoServiceService";

class CompanyService {
  // クラスのメンバ変数として保存するプロパティを定義
  userName: string = "";
  companyCode: string = "";
  companyName: string = "";
  officeCode: string = "";
  officeName: string = "";
  serviceType: string = "";

  role: string[] | null = [];

  csrfToken: string = "";
  response: any = null;
  userInfo: UserInfo = new UserInfo();
  // tblMService = new TblMServiceService();
  // tblMSogoService = new TblMSogoServiceService();

  // クラスメソッドとしてfetchCompanyDataを定義
  async fetchCompanyData(): Promise<boolean> {
    try {
      if (!this.csrfToken || this.csrfToken == "") {
        axios.defaults.withCredentials = true; //Cookieの場合
        await axios
          .get(`${import.meta.env.VITE_API_TARGET}/csrf-token`)
          .then((response) => {
            this.csrfToken = response.data.csrfToken;
            //sessionStorage.setItem('csrfToken', this.csrfToken);
          });
      }

      // 2. 会社情報を取得
      this.response = await axios.get(
        `${import.meta.env.VITE_API_TARGET}/api/GetCompanyInfo`,
        {
          headers: {
            "X-CSRF-TOKEN": this.csrfToken,
            "X-Requested-With": "XMLHttpRequest", // AJAX識別用
          },
        },
      );
      //const response = await axios.get(`${import.meta.env.VITE_API_TARGET}/api/GetCompanyInfo`);
      const data = this.response.data;
      sessionStorage.setItem("token", this.response.data.token); //Tokenの場合
      //console.debug(response.data.token);

      // データをクラスのメンバ変数に保存
      this.userName = data.userName;
      this.companyCode = data.companyCode;
      this.companyName = data.companyName;
      this.officeCode = data.officeCode;
      this.officeName = data.officeName;
      this.serviceType = data.serviceType;
      this.role = data.role;

      if (!sessionStorage.getItem("userName")) {
        const tblMService = new TblMServiceService();
        const tblMSogoService = new TblMSogoServiceService();

        tblMService.getMonthServices(new Date("1990-01-01"));

        tblMSogoService.getMonthServices(new Date("1990-01-01"));
      }

      // データをVue.jsのコンポーネントに保存する
      console.log("Company Data:", data);
      sessionStorage.setItem("userName", data.userName);
      sessionStorage.setItem("companyCode", data.companyCode);
      sessionStorage.setItem("companyName", data.companyName);
      sessionStorage.setItem("officeCode", data.officeCode);
      sessionStorage.setItem("officeName", data.officeName);
      sessionStorage.setItem("serviceType", data.serviceType);

      return true;
    } catch (error) {
      console.error("Failed to fetch company data:", error);
      this.clearStoredData();
      return false;
    }
  }

  // クラスメソッドとしてfetchCompanyDataを定義
  async fetchCompanyDataByMinimalAPI(): Promise<boolean> {
    try {
      this.userInfo.userName = this.userName;
      this.userInfo.companyCode = this.companyCode;
      this.userInfo.officeCode = this.officeCode;
      this.userInfo.serviceType = this.serviceType;

      const token = sessionStorage.getItem("token");

      if (!token) {
        // tokenがnullの場合
        return false;
      }

      const token_minimal_api = sessionStorage.getItem("token_minimal_api");

      if (token_minimal_api) {
        // token_minimal_apiがnullでない場合
        return true;
      }

      const responseByMinimalAPI = await axios.post(
        `${
          import.meta.env.VITE_LOCAL_API_TARGET
        }/localapi/CompanyInfo/AuthUser`,
        this.userInfo,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      const data = responseByMinimalAPI.data;
      sessionStorage.setItem("token_minimal_api", data); //Tokenの場合

      return true;
    } catch (error) {
      console.error("Failed to fetch company data:", error);
      this.clearStoredData();
      return false;
    }
  }

  async setCompanyData(data: any): Promise<boolean> {
    try {
      // データをクラスのメンバ変数に保存
      this.userName = data.userName;
      this.companyCode = data.companyCode;
      this.companyName = data.companyName;
      this.officeCode = data.officeCode;
      this.officeName = data.officeName;
      this.serviceType = data.serviceType;
      this.role = data.role;

      // データをVue.jsのコンポーネントに保存する
      console.log("Company Data:", data);
      sessionStorage.setItem("userName", data.userName);
      sessionStorage.setItem("companyCode", data.companyCode);
      sessionStorage.setItem("companyName", data.companyName);
      sessionStorage.setItem("officeCode", data.officeCode);
      sessionStorage.setItem("officeName", data.officeName);
      sessionStorage.setItem("serviceType", data.serviceType);

      return true;
    } catch (error) {
      console.error("Failed to fetch company data:", error);
      this.clearStoredData();
      return false;
    }
  }

  // メンバ変数からデータを取得するためのゲッターメソッド
  getStoredData() {
    return {
      userName: this.userName,
      companyCode: this.companyCode,
      companyName: this.companyName,
      officeCode: this.officeCode,
      officeName: this.officeName,
      serviceType: this.serviceType,
    };
  }

  clearStoredData() {
    this.userName = "";
    this.companyCode = "";
    this.companyName = "";
    this.officeCode = "";
    this.officeName = "";
    this.serviceType = "";

    sessionStorage.removeItem("userName");
    sessionStorage.removeItem("companyCode");
    sessionStorage.removeItem("companyName");
    sessionStorage.removeItem("officeCode");
    sessionStorage.removeItem("officeName");
    sessionStorage.removeItem("serviceType");
    sessionStorage.removeItem("staffCode");
    sessionStorage.removeItem("staffName");
  }
}

// // クラスをエクスポート
export default new CompanyService();
